import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {AssignProductUserEntitlementsResultModal} from './assign-product-user-entitlements.result.modal';
import {
    clearResult,
    selectAssignProductUserEntitlementsBulkUuid,
    selectAssignProductUserEntitlementsShown,
    selectAssignProductUserEntitlementsTask,
} from './assign-product-user-entitlements.slice';


export const AssignProductUserEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectAssignProductUserEntitlementsBulkUuid}
        actionTaskSelector={selectAssignProductUserEntitlementsTask}
        actionShownSelector={selectAssignProductUserEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <AssignProductUserEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
